/*inspiration-and-prior-art*/
/*additional-thanks*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "致谢",
  "description": "感谢所有开发者、构建系统和 Monorepo 工具的支持和帮助。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 最初由 Jared Palmer 创建，是一款闭源企业软件产品。2021 年末，Vercel 收购 Turborepo 开源了代码库。"
  }, {
    "heading": "",
    "content": "¥Turborepo was originally created by Jared Palmer as a closed-source enterprise software offering. In late 2021, Vercel acquired Turborepo and open sourced the codebase."
  }, {
    "heading": "",
    "content": "如今，Turborepo 拥有一支全职团队致力于此，并且其 开源贡献者 列表也在不断增加。"
  }, {
    "heading": "",
    "content": "¥Today, Turborepo has a dedicated full-time team working on it as well as a growing list of open source contributors."
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥Inspiration and Prior Art"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "在 Vercel，我们深信开源运动和开放协作的力量。为此，对激励我们和我们工作的项目和人员进行有意义的归因至关重要。"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥At Vercel, we believe deeply in the open source movement and in the power of open collaboration. To that end, it's important to provide meaningful attribution to the projects and people that inspire(d) us and our work."
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "我们想特别感谢其他构建系统、monorepo 工具和现有技术："
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥We'd like to make a special shoutout to other build systems, monorepo tools, and prior art:"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Bazel - https://bazel.build"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Buck - https://buck.build"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "请 - https://please.build"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥Please - https://please.build"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Pants - https://www.pantsbuild.org"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Scoot - https://github.com/twitter/scoot"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "TSDX - https://tsdx.io"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Lerna - https://lerna.nodejs.cn"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Lage - https://microsoft.github.io/lage"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "回填 - https://github.com/microsoft/backfill"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥Backfill - https://github.com/microsoft/backfill"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Bolt - https://github.com/boltpkg/bolt"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Rush - https://rushjs.io"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "预构建 - https://preconstruct.tools"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥Preconstruct - https://preconstruct.tools"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Nx - https://nx.dev"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "Yarn - https://yarn.nodejs.cn"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "npm - https://www.npmjs.com"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "pnpm - https://pnpm.nodejs.cn"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "在整个文档中，只要适用，我们还提供了内联标注和链接，指向那些给予我们启发的项目和人员。"
  }, {
    "heading": "灵感和现有技术-inspiration-and-prior-art",
    "content": "¥Throughout the documentation, wherever applicable, we also provide inline callouts and links to the projects and people that have inspired us."
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Additional Thanks"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "此外，我们感谢："
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Additionally, we're grateful to:"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Rick Button 感谢在 npm 上捐赠 turbo 软件包名称"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Rick Button for donating the turbo package name on npm"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Iheanyi Ekechukwu 感谢在疫情期间帮助 Jared 学习 Golang！"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Iheanyi Ekechukwu for helping Jared pick up Golang during the Pandemic!"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Kenneth Chau 感谢 Lage 的作用域和管道 API 及文档"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Kenneth Chau for Lage's Scope and Pipeline API and docs"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "用于试用 Turborepo 的 Miguel Oller 和 MakeSwift.com"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Miguel Oller and MakeSwift.com for piloting Turborepo"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "用于 Turborepo 试用的 Eric Koslow、Jack Hanford 和 Lattice.com"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Eric Koslow, Jack Hanford, and Lattice.com for piloting Turborepo"
  }],
  "headings": [{
    "id": "灵感和现有技术-inspiration-and-prior-art",
    "content": "灵感和现有技术 /*inspiration-and-prior-art*/"
  }, {
    "id": "致谢-additional-thanks",
    "content": "致谢 /*additional-thanks*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#灵感和现有技术-inspiration-and-prior-art",
  title: _jsx(_Fragment, {
    children: "灵感和现有技术 "
  })
}, {
  depth: 2,
  url: "#致谢-additional-thanks",
  title: _jsx(_Fragment, {
    children: "致谢 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 最初由 ", _jsx(_components.a, {
        href: "https://x.com/jaredpalmer",
        children: "Jared Palmer"
      }), " 创建，是一款闭源企业软件产品。2021 年末，", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "Vercel 收购 Turborepo"
      }), " 开源了代码库。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo was originally created by ", _jsx(_components.a, {
        href: "https://x.com/jaredpalmer",
        children: "Jared Palmer"
      }), " as a closed-source enterprise software offering. In late 2021, ", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "Vercel acquired Turborepo"
      }), " and open sourced the codebase."]
    }), "\n", _jsxs(_components.p, {
      children: ["如今，Turborepo 拥有一支全职团队致力于此，并且其 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/graphs/contributors",
        children: "开源贡献者"
      }), " 列表也在不断增加。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Today, Turborepo has a dedicated full-time team working on it as well as a growing list of ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/graphs/contributors",
        children: "open source contributors"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "灵感和现有技术-inspiration-and-prior-art",
      children: "灵感和现有技术 "
    }), "\n", _jsx(_components.p, {
      children: "¥Inspiration and Prior Art"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "，我们深信开源运动和开放协作的力量。为此，对激励我们和我们工作的项目和人员进行有意义的归因至关重要。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥At ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), ", we believe deeply in the open source movement and in the power of open collaboration. To that end, it's important to provide meaningful attribution to the projects and people that inspire(d) us and our work."]
    }), "\n", _jsx(_components.p, {
      children: "我们想特别感谢其他构建系统、monorepo 工具和现有技术："
    }), "\n", _jsx(_components.p, {
      children: "¥We'd like to make a special shoutout to other build systems, monorepo tools, and prior art:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bazel - ", _jsx(_components.a, {
            href: "https://bazel.build",
            children: "https://bazel.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Buck - ", _jsx(_components.a, {
            href: "https://buck.build",
            children: "https://buck.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["请 - ", _jsx(_components.a, {
            href: "https://please.build",
            children: "https://please.build"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Please - ", _jsx(_components.a, {
            href: "https://please.build",
            children: "https://please.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Pants - ", _jsx(_components.a, {
            href: "https://www.pantsbuild.org",
            children: "https://www.pantsbuild.org"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Scoot - ", _jsx(_components.a, {
            href: "https://github.com/twitter/scoot",
            children: "https://github.com/twitter/scoot"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["TSDX - ", _jsx(_components.a, {
            href: "https://tsdx.io",
            children: "https://tsdx.io"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Lerna - ", _jsx(_components.a, {
            href: "https://lerna.nodejs.cn",
            children: "https://lerna.nodejs.cn"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Lage - ", _jsx(_components.a, {
            href: "https://microsoft.github.io/lage",
            children: "https://microsoft.github.io/lage"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["回填 - ", _jsx(_components.a, {
            href: "https://github.com/microsoft/backfill",
            children: "https://github.com/microsoft/backfill"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Backfill - ", _jsx(_components.a, {
            href: "https://github.com/microsoft/backfill",
            children: "https://github.com/microsoft/backfill"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bolt - ", _jsx(_components.a, {
            href: "https://github.com/boltpkg/bolt",
            children: "https://github.com/boltpkg/bolt"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Rush - ", _jsx(_components.a, {
            href: "https://rushjs.io",
            children: "https://rushjs.io"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["预构建 - ", _jsx(_components.a, {
            href: "https://preconstruct.tools",
            children: "https://preconstruct.tools"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Preconstruct - ", _jsx(_components.a, {
            href: "https://preconstruct.tools",
            children: "https://preconstruct.tools"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Nx - ", _jsx(_components.a, {
            href: "https://nx.dev",
            children: "https://nx.dev"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Yarn - ", _jsx(_components.a, {
            href: "https://yarn.nodejs.cn",
            children: "https://yarn.nodejs.cn"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["npm - ", _jsx(_components.a, {
            href: "https://www.npmjs.com",
            children: "https://www.npmjs.com"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["pnpm - ", _jsx(_components.a, {
            href: "https://pnpm.nodejs.cn",
            children: "https://pnpm.nodejs.cn"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "在整个文档中，只要适用，我们还提供了内联标注和链接，指向那些给予我们启发的项目和人员。"
    }), "\n", _jsx(_components.p, {
      children: "¥Throughout the documentation, wherever applicable, we also provide inline callouts and links to the projects and people that have inspired us."
    }), "\n", _jsx(_components.h2, {
      id: "致谢-additional-thanks",
      children: "致谢 "
    }), "\n", _jsx(_components.p, {
      children: "¥Additional Thanks"
    }), "\n", _jsx(_components.p, {
      children: "此外，我们感谢："
    }), "\n", _jsx(_components.p, {
      children: "¥Additionally, we're grateful to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/rickbutton",
            children: "Rick Button"
          }), " 感谢在 npm 上捐赠 ", _jsx(_components.code, {
            children: "turbo"
          }), " 软件包名称"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/rickbutton",
            children: "Rick Button"
          }), " for donating the ", _jsx(_components.code, {
            children: "turbo"
          }), " package name on npm"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/kwuchu",
            children: "Iheanyi Ekechukwu"
          }), " 感谢在疫情期间帮助 Jared 学习 Golang！"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/kwuchu",
            children: "Iheanyi Ekechukwu"
          }), " for helping Jared pick up Golang during the Pandemic!"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/kenneth_chau",
            children: "Kenneth Chau"
          }), " 感谢 Lage 的作用域和管道 API 及文档"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/kenneth_chau",
            children: "Kenneth Chau"
          }), " for Lage's Scope and Pipeline API and docs"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["用于试用 Turborepo 的 ", _jsx(_components.a, {
            href: "https://x.com/ollermi",
            children: "Miguel Oller"
          }), " 和 ", _jsx(_components.a, {
            href: "https://www.makeswift.com/",
            children: "MakeSwift.com"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/ollermi",
            children: "Miguel Oller"
          }), " and ", _jsx(_components.a, {
            href: "https://www.makeswift.com/",
            children: "MakeSwift.com"
          }), " for piloting Turborepo"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["用于 Turborepo 试用的 ", _jsx(_components.a, {
            href: "https://x.com/ekosz1",
            children: "Eric Koslow"
          }), "、", _jsx(_components.a, {
            href: "https://x.com/jackhanford",
            children: "Jack Hanford"
          }), " 和 ", _jsx(_components.a, {
            href: "https://lattice.com/",
            children: "Lattice.com"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/ekosz1",
            children: "Eric Koslow"
          }), ", ", _jsx(_components.a, {
            href: "https://x.com/jackhanford",
            children: "Jack Hanford"
          }), ", and ", _jsx(_components.a, {
            href: "https://lattice.com/",
            children: "Lattice.com"
          }), " for piloting Turborepo"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
